import { Pipe, PipeTransform } from '@angular/core';
import { NgxFloatUiPlacements } from 'ngx-float-ui';

type TEnum = NgxFloatUiPlacements;

@Pipe({
  name: 'enum',
})
export class EnumPipe implements PipeTransform {
  private enums: { [key: string]: Record<string, unknown> } = {
    FloatUiPlacements: NgxFloatUiPlacements,
  };

  public transform(value: string, enumName: string): TEnum {
    if (!this.enums[enumName]) {
      throw new Error(`Enum ${enumName} not found`);
    }

    return this.enums[enumName][value] as TEnum;
  }
}
